import React from 'react';
import { connect } from 'react-redux';
import * as selectors from 'selectors/pathBuilder';
import EstimatedDuration from 'components/Learn/shared/LearnContentCard/EstimatedDuration';
import { withStatusModifier } from '../helpers';
import ContentWrapper from './Wrapper';
import ActionButton from './ActionButton';
import Step from './Step';
import Status from './Status';

function LessonContent({
  status,
  formattedStatus,
  progress,
  urls,
  stepNumber,
  type,
  required,
  dateAdded,
  dueDate,
  isOverdue,
  id,
  ...props
}) {
  return (
    <ContentWrapper>
      <div className={`${withStatusModifier('PathContent', status)}`}>
        <div className="w-fill">
          <div className="PathContent-header">
            <h1 className="PathContent-title">{props.title}</h1>
            <Status
              {...{
                progress,
                status,
                formattedStatus,
                urls,
                required,
                dateAdded,
                dueDate,
                isOverdue,
              }}
              {...props}
            />
          </div>
          {!!props.description && (
            <div className="PathContent-body">
              <p className="PathContent-description f-smooth">
                {props.description}
              </p>
            </div>
          )}
          {props.estimatedMinutesToComplete && (
            <div className="ml-24 pb-16">
              <EstimatedDuration
                estimatedMinutesToComplete={props.estimatedMinutesToComplete}
              />
            </div>
          )}
          {!status.match(/upcoming|locked|awaitingReassignment/i) && (
            <ActionButton status={status} type={type} urls={urls} />
          )}
          <Step {...{ stepNumber, status, progress, id }} />
        </div>
      </div>
    </ContentWrapper>
  );
}

function mapStateToProps() {
  const getStepNumber = selectors.getStepNumber();
  return (state, props) => ({
    stepNumber: getStepNumber(state.pathViewer, props),
  });
}

export default connect(mapStateToProps)(LessonContent);
